import { render, staticRenderFns } from "./datosBasicosFuturo.vue?vue&type=template&id=36e076f0&scoped=true&"
import script from "./datosBasicosFuturo.vue?vue&type=script&lang=js&"
export * from "./datosBasicosFuturo.vue?vue&type=script&lang=js&"
import style0 from "./datosBasicosFuturo.vue?vue&type=style&index=0&id=36e076f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e076f0",
  null
  
)

export default component.exports